module.exports = __webpack_public_path__ + "static/media/tindastoll.5383f7d7.svg";